import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';

export default function CustomFieldFormDealTypes({ dealTypes, options, onChange }) {
  const optionGroups = [];
  let optionGroup;
  for (const [i, option] of options.dealTypes.entries()) {
    if (i % 2 === 0) {
      optionGroup = [];
      optionGroups.push(optionGroup);
    }

    optionGroup.push(option);
  }

  function toggleDealType(dealType) {
    if (dealTypes.includes(dealType)) {
      onChange({ dealTypes: dealTypes.filter(type => type !== dealType) });
    } else {
      onChange({ dealTypes: [...dealTypes, dealType] });
    }
  }

  return (
    <div className="form-group required">
      <label className="form-label">
        Deal Types
      </label>
      <div className="d-flex flex-wrap">
        {optionGroups.map((optionGroup, i) => (
          <div className="me-5" key={i}>
            {optionGroup.map(option => (
              <ManagedInput
                checked={dealTypes.includes(option.value)}
                key={option.value}
                label={option.label}
                type="checkbox"
                wrapperClassName="m-0 pt-2 text-nowrap"
                onChange={() => toggleDealType(option.value)}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

CustomFieldFormDealTypes.propTypes = {
  dealTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  options: PropTypes.shape({
    dealTypes: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
